import React from "react";
import { Contact, Header, Hire } from "./Components";

const PlagiarismCheckingandRemoval = () => {
  return (
    <div className="servicesPages">
      <Header
        header="Worried About Rejection Due to Plagiarized Content?"
        desc="We utilize a robust multi-level plagiarism detection system to thoroughly examine your documents. Rest assured, any detected plagiarism will be completely eliminated to ensure originality and compliance."
      />
      <div className="body">
        <div>
          <div className="header">Plagiarism Checking and Removal Service</div>
          <div className="desc">
            Plagiarism is one of the leading causes of document rejection by organizations such as Engineers Australia (EA), the Australian Computer Society (ACS), and the
            Institution of Professional Engineers New Zealand (IPENZ). According to the MSA rule booklet, plagiarism is considered an illegal act, and documents found to contain
            copied content from sources like journals, articles, magazines, digital platforms, or other sources will face immediate rejection.
          </div>
          <div className="desc">
            Applicants preparing reports such as CDR, RPL, or KA02 themselves may unintentionally include plagiarized content from references or data sourced from various online
            platforms. Directly using content from websites or online resources without paraphrasing also leads to plagiarism, increasing the risk of rejection. Ensuring the
            originality of your documents is crucial for successful submission.
          </div>
          <div className="desc">
            At CDR Report Hub, we offer professional plagiarism-checking and removal services to ensure your content is entirely unique. Using the best plagiarism detection tools,
            we identify exact sentences, paragraphs, or data copied from published sources. Our expert writers then paraphrase and edit the content, ensuring your document is free
            of plagiarism and fully compliant with MSA guidelines. Trust us to deliver 100% original and high-quality content tailored to your needs.
          </div>
          <div className="header">What is Plagiarism?</div>
          <div className="desc">
            Plagiarism refers to copying words, sentences, ideas, concepts, or images from published materials and presenting them as your own without giving proper credit to the
            original author. It is a serious violation that can lead to the rejection of your CDR report or any other professional documentation.
          </div>
          <div className="desc">
            To ensure your CDR report is accepted, it must be entirely free of plagiarism. At CDR Report Hub, we offer expert guidance on creating plagiarism-free reports, ensuring
            originality and compliance with professional standards for successful submission.
          </div>
        </div>
      </div>
      <Contact />
      <Hire />
    </div>
  );
};

export default PlagiarismCheckingandRemoval;
